/** @jsxImportSource @emotion/react */
import { Button, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useContext, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyledTextField } from '../../Components/CustomTextfield';
import getCookie from '../../Helper/Cookies/cookies';
import { Il8nContext } from '../../Helper/i18n';
import { addStageData } from '../../Helper/Redux/reducers/upDown';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useEffect } from 'react';
import ResendButton from './ResendButton';
import TextLoader from '../../Components/TextLoader';
import ReCAPTCHA from 'react-google-recaptcha';

function Login(props) {
    const { showProceed ,setShowProceed, timerCaptcha,setTimerCaptcha} = props
    const store = useSelector(state => state.storeState.stage)

    const dispatch = useDispatch()
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const urlSegments = window.location.href
    const urlParams = new URL(urlSegments).searchParams
    const localeText = useContext(Il8nContext)

    useEffect(()=>{
        if (localStorage.getItem("otpVer")){
            formik.setFieldValue("mobile", localStorage.getItem("otpVer"))
        }
        if (urlParams.get("mobile")) {
            formik.setFieldValue("mobile", window.atob(urlParams.get("mobile")))
            let values = {
                mobile: window.atob(urlParams.get("mobile")),
                email: window.atob(urlParams.get("email"))
            }
            dispatch(addStageData({ ...store, ...values }))
            if(urlParams.get("mobile") && urlParams.get("otpToken")){
                props.handleSubmit("noCall", values)
                setShowProceed(true)
            }
            else{
                props.handleSubmit("sendOTP", values)
            }
        }
    }, [])


    const allURLParamsArray = () => {
        let a = [];
        for (let key of urlParams.keys()) {
            a.push(key)
        }
        return a;
    }

    const handleVerifyClick = (values) => {
        props.setLoader(true)
        // if (!store.mobile) {
        //     !(store?.error?.find(ele => ele == "mobile")) && dispatch(addStageData({ ...store, error: store.error ? [...store.error, "mobile"] : ["mobile"] }))
        // // }
        //if (!urlParams.get("isDigital") && !(allURLParamsArray().length === 2 && allURLParamsArray().find(item => item == "mobile") && allURLParamsArray().find(item => item == "sb")) && !getCookie("referalCode")) {
        //    props.handleSubmit(undefined, values)
        //}
        if (!urlParams.get("parm_LeadCity") && !urlParams.get("city")) {
            // setConfirmLocationPopup(true)
            props.getLatLong(values)
        }
        else {
            props.handleSubmit("sendOTP", values)
            // store.dispatch(submit("SignUp"))
        }
    }

    const onRecaptchaChange = (val) =>{
        if(val && !showProceed){
            props?.setIsCaptcha(false)
        }else if(val && timerCaptcha){
          props?.setIsCaptcha(false)
          props.handleSubmit("sendOTP", { mobile: formik?.values?.mobile, captchaResponse: props?.googleCaptchaRef?.current?.getValue()})
        }
    }

    const validationSchema = yup.object({
        mobile: yup
            .number('')
            .required(localeText?.loginMobileRequired)
            .typeError(localeText?.loginInvalidNo)
    });

    const formik = useFormik({
        initialValues: {
            mobile: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            dispatch(addStageData({ ...store, ...values }))
            handleVerifyClick(values)
        },
    });

    const validationSchema2 = yup.object({
        otp: yup
            .number('')
            .required(localeText?.loginRequired)
            .typeError(localeText?.loginInvalid)
    });

    const formik2 = useFormik({
        initialValues: {
            otp: '',
        },
        validationSchema: validationSchema2,
        onSubmit: (values) => {
            props.setLoader(true)
            dispatch(addStageData({ ...store, ...values, mobile : formik.values.mobile }))
            window && window.dataLayer?.push({
              "enhanced_conversion_data": {
              "email":store.email,
              "phone_number": `+91${formik.values.mobile}`
              }
            })
            props.handleSubmit("verifyOTP", {...values, mobile : formik.values.mobile})
        },
    });

    return (
        
        <Grid container md={6} item // Welcome
            css={{ padding: "3% 7%", paddingLeft: isSmallScreen ? "7%" : "10%" }}
        >
            <Grid item xs={12}>
                <Typography css={{ fontWeight: "bold", lineHeight: "50px", fontSize: isSmallScreen ? "22px" : "30px", color: "#0098B0" }}>
                    {localeText?.loginHello}
                </Typography>
            </Grid>
            {!showProceed ?
        <form autocomplete="off" onSubmit={formik.handleSubmit} css={{ width: "100%" }}>
          <Grid item xs={12}>
            <StyledTextField id="mobile" name="mobile" css={{ marginTop: "10px" }}
              InputLabelProps={{
                shrink: true,
              }}
              value={formik.values.mobile}
              required
              error={formik.touched.mobile && Boolean(formik.errors.mobile)}
              helperText={formik.touched.mobile && formik.errors.mobile}
              inputProps={{ maxLength: 10 }} fullWidth label={localeText?.loginMobile} variant="outlined"
              onChange={formik.handleChange}
            />
          </Grid>
          <Grid item xl={12} lg={12} md={3} sm={12} xs={12}>
            {
              !props?.isVerified &&
              <Grid sx={{ width: 'auto', border: `${props?.isCaptcha ? "1px solid red" : ""}`, boxShadow: `${props?.isCaptcha ? 3 : ""}`, display: 'flex', flexDirection: 'column', mt: "10px" }}>
                <ReCAPTCHA
                  ref={props.googleCaptchaRef}
                  style={{ width: '100%', display: "inline-block", margin: "10px 0px 0px 10px", transform: 'scale(0.95)', transformOrigin: "0 0" }}
                  size={"normal"}
                  sitekey="6LcaCSkeAAAAAHe_pYkugmdMro_bmzcoFk8HiCZj"
                  onChange={onRecaptchaChange}
                />
                <Typography variant='p' sx={{ color: 'red', padding: "0px 0px 10px 10px", fontWeight: 'bold' }}>{props?.isCaptcha ? localeText?.captchaResponseMissing : ""}</Typography>
              </Grid>
            }
          </Grid>
          <Grid item xs={12}>
            <Button type="submit" /* disabled={formik.values.mobile.length<10} */ disabled={props.enableOtp} css={{ marginTop: "10px" }} fullWidth variant="contained" color="primary">
              {props.loader ? <TextLoader name={localeText?.loginSending} /> : localeText?.loginVerify}
            </Button>
            <div css={{ textAlign: "center", marginTop: "20px" }}>
              <Typography variant='caption' css={{ textDecoration: "underline", color: "#008FFF", cursor: "pointer" }} onClick={() => props.guestLogin()}>
                {localeText?.loginResume}
              </Typography>
            </div>
          </Grid>
        </form> :
        <form autocomplete="off" onSubmit={formik2.handleSubmit} css={{ width: "100%" }}>
          <Grid item xs={12} css={{ marginTop: "40px" }}>
              <Typography variant='h6' css={{ color: "#0098B0", fontWeight: 'bold', padding: '10px 0px' }}>
                Mobile Number : <span style={{display:'inline-block'}}><Typography variant='h6' css={{ color: "#0098B0", fontWeight: 'bold', padding: '10px 0px' }}>
                {store?.mobile}</Typography></span> </Typography>
              
            <StyledTextField id="otp" name="otp" InputLabelProps={{
              shrink: true,
            }}
              error={formik2.touched.otp && Boolean(formik2.errors.otp)}
              value={formik2.values.mobile}
              helperText={formik2.touched.otp && formik2.errors.otp}
              inputProps={{ maxLength: 6 }}
              fullWidth label={localeText?.loginEnterotp} variant="outlined"
              onChange={formik2.handleChange}
              // disabled={!props.enableOtp}
              required
            />
            <Grid item xs={12} css={{ marginTop: "10px" }}>
              <Button type="submit" disabled={props.loader} css={{ backgroundColor: "#24B7CC", ":hover": { backgroundColor: "#24B7CC" } }} fullWidth variant="contained" color="primary" >
                {localeText?.loginProceed}
              </Button>
            </Grid>
          </Grid>
            <Grid>
            <ResendButton
                onClick={() => props.handleSubmit("sendOTP", { mobile: formik.values.mobile, captchaResponse: props?.googleCaptchaRef?.current?.getValue() })}
                timeOut={59} setTimerCaptcha={setTimerCaptcha}
              />
            </Grid>
          {timerCaptcha && <Grid item xl={12} lg={12} md={3} sm={12} xs={12}>
            <Grid sx={{ width: 'auto', border: `${props?.isCaptcha ? "1px solid red" : ""}`, boxShadow: `${props?.isCaptcha ? 3 : ""}`, display: 'flex', flexDirection: 'column', mt: "25px" }}>
              <ReCAPTCHA
                ref={props.googleCaptchaRef}
                style={{ width: '100%', display: "inline-block", margin: "10px 0px 0px 10px", transform: 'scale(0.95)', transformOrigin: "0 0" }}
                size={"normal"}
                sitekey="6LcaCSkeAAAAAHe_pYkugmdMro_bmzcoFk8HiCZj"
                onChange={onRecaptchaChange}
              />
              <Typography variant='p' sx={{ color: 'red', padding: "0px 0px 10px 10px", fontWeight: 'bold' }}>{props?.isCaptcha ? localeText?.captchaResponseMissing : ""}</Typography>
            </Grid>         
          </Grid>}
        </form>}
        </Grid>
    );
}

export default Login;